import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

import {
    cannedCommandRequest,
    clearRedux,
} from 'Redux/actions';

const DeleteCannedCommand = (props) => {
    const { tableRef } = props;
    const dispatch = useDispatch();
    const { messages } = useIntl();

    const { openModal, loading, result, cannedCommand } = useSelector(state => state.deleteCannedCommandRedux);

    const closeModal = () => {
        dispatch(clearRedux("DELETE_CANNEDCOMMANDS"));
    }

    const applyChanges = () => {
        dispatch(cannedCommandRequest(cannedCommand?.id));
    }

    useEffect(() => {
        if (result) {
            if (result?.delete) {
                closeModal();
                NotificationManager.success(
                    messages['delete_cannedcommand_success_message'],
                    messages['delete_cannedcommand_title'],
                    3000
                );
                tableRef && tableRef?.current?.getData();
            }
            else {
                NotificationManager.error(
                    messages['delete_cannedcommand_error_message'],
                    messages['delete_cannedcommand_title'],
                    3000
                );
                dispatch(clearRedux("DELETE_CANNEDCOMMANDS", { result: null }));
            }
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={`${messages['delete_cannedcommand_title']} ${cannedCommand?.label ? `(${cannedCommand?.label})` : ""}`}
            loading={loading}
            position="right"
            size="small"
            handleClose={closeModal}
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    <label style={{ marginBottom: 5 }}>
                        {messages['delete_cannedcommand_label']}
                    </label>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => applyChanges()}
                >
                    {messages['delete']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default DeleteCannedCommand;